import { Button, IButton } from '../../button';
import Component from '../../component/component';

import './notification.scss';

export interface INotification {
    content: string;
    button: IButton;
    actions?: IButton[];
    modifier?: string;
}

export default class Notification extends Component {
    static initSelector: string = '.notification';

    closeButton: HTMLElement;

    constructor(element: HTMLElement) {
        super(element);

        this.closeButton = this.element.querySelector('.js-notification-close');

        this.init();
    }

    public static get shouldShow(): boolean {
        return false;
    }

    public static render(data: INotification, className: string = ''): HTMLElement {
        const block: HTMLDivElement = document.createElement('div');
        const contentElement: HTMLDivElement = document.createElement('div');
        const actionsElement: HTMLDivElement = document.createElement('div');

        block.setAttribute('role', 'status');
        block.setAttribute('aria-live', 'polite');
        block.classList.add('notification');

        if (className) {
            block.classList.add(...className.split(' ').filter((name: string) => !!name));
        }

        contentElement.classList.add(...['notification__content', 'text']);
        actionsElement.classList.add('notification__action-list');

        const closeButton: string = Button.render({
            className: 'button--tiny notification__action js-notification-close',
            data: data.button,
        });

        if (data.actions) {
            for (const action of data.actions) {
                actionsElement.append(Button.render({
                    className: 'button--tiny notification__action',
                    data: action,
                }));
            }
        }

        actionsElement.innerHTML += closeButton;
        contentElement.innerHTML += data.content;
        block.append(contentElement);
        block.append(actionsElement);

        return block;
    }

    init(): void {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', this.handleCloseClick);
        }
    }

    handleCloseClick: (event: MouseEvent) => void = (event: MouseEvent) => {
        event.preventDefault();

        this.hide();

        this.element.addEventListener('transitionend', (e: TransitionEvent) => {
            if (e.target === e.currentTarget && e.propertyName === 'transform') {
                this.remove();
            }
        });
    };

    show(): void {
        window.setTimeout(() => {
            this.element.classList.add('is-visible');
        });
    }

    hide(): void {
        this.element.classList.remove('is-visible');
    }

    remove(): void {
        this.element.remove();
    }
}
